// The old Details screen's styles. The screen went on 12 Oct 2026; Book & pay
// (step-book/styles.js) still builds its fields on these. Only what Book &
// pay still uses is left (19 Oct 2026: the size button classes, which Book &
// pay restyles itself, and eleven unused ones went, for the bundle budget).
export const styles = theme => ({
  page: {
    background: '#f5f7fa',
    minHeight: '100%',
    // Extra bottom padding on narrow viewports keeps the bottom form
    // fields + inline Next button clear of the sticky MobileBookingBar
    // (~76px tall incl. iOS safe-area-inset-bottom).
    padding: '24px 16px 120px',
    '@media (min-width: 720px)': {
      padding: '24px 16px 48px'
    },
    '@media (min-width: 960px)': {
      padding: '40px 32px 64px'
    }
  },
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    margin: '0 auto',
    maxWidth: 560,
    '@media (min-width: 960px)': {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 40,
      maxWidth: 960
    }
  },
  formCol: {
    flex: '1 1 auto',
    minWidth: 0,
    '@media (min-width: 960px)': {
      maxWidth: 560
    }
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 1px 3px rgba(15,23,42,0.04), 0 4px 16px rgba(15,23,42,0.04)',
    padding: '28px 24px',
    '@media (min-width: 600px)': {
      padding: '36px 40px'
    }
  },
  section: {
    paddingTop: 20,
    marginTop: 20,
    borderTop: '1px solid #eef0f3',
    '&:first-child': {
      paddingTop: 0,
      marginTop: 0,
      borderTop: 'none'
    }
  },
  sectionHeading: {
    // Eyebrow label - small uppercase, near-weightless, so the step reads as
    // a few quick groups rather than several big "things to do".
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    lineHeight: 1.25,
    color: '#64748b',
    margin: '0 0 10px 0'
  },
  fieldLabel: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 13,
    fontWeight: 500,
    color: '#334155',
    marginBottom: 6,
    display: 'block'
  },
  field: {
    position: 'relative',
    background: '#fff',
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    padding: '4px 14px',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    cursor: 'text',
    '&:hover': {
      borderColor: '#cbd5e1'
    },
    // The Postcoder suggestions dropdown styles that used to be anchored
    // here went with the autocomplete itself (2026-09-17) and the geocoder
    // echo under the field went with the geocoder (2026-10-04).
    // Make MUI inputs fill the wrapper
    '& .MuiFormControl-root, & .MuiTextField-root': {
      width: '100%'
    },
    '& .MuiInputBase-root': {
      width: '100%',
      fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
      fontSize: 15,
      color: '#0f172a',
      padding: '8px 0'
    },
    '& .MuiInputBase-input': {
      flex: 1,
      width: '100%',
      padding: '6px 0',
      // Hide native search input "x" clear button (Chrome/Safari)
      '&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration': {
        display: 'none'
      }
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#94a3b8',
      opacity: 1
    },
    '& .MuiFormLabel-root': {
      display: 'none'
    },
    '& .book-now-control-icon': {
      fill: '#94a3b8'
    }
  },
  fieldInvalid: {
    borderColor: '#ef4444',
    boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.12)'
  },
  inlineCheckRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 0',
    cursor: 'pointer',
    userSelect: 'none'
  },
  inlineCheckText: {
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 14,
    color: '#334155'
  },
  sidebarCol: {
    display: 'none',
    '@media (min-width: 960px)': {
      display: 'block',
      flex: '0 0 320px',
      position: 'sticky',
      // Clears the sticky BookingStepper (~68px) plus 20px breathing room
      // so the summary sits just below it instead of sliding underneath.
      top: 88
    }
  }
})
